import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center px-4 sm:px-6 lg:px-8 md:min-h-[75vh] py-8 sm:py-20" }

import SignInRoot from '@/components/login/SignInRoot.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// Components

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SignInRoot)
  ]))
}
}

})